export const usePhone = () => {
  const formatPhoneForTel = (phone: string) => {
    return phone.replace(/\s+/g, '')
  }

  return {
    formatPhoneForTel
  }
}
